import {checkChildrenDimensions} from "../../../../../../../JsonScreen/Utils/checkForPercentHeight";
import {primaryDropColor} from "../../ScreenBar";

export function getComponentStyles(styles, stylesLength, isSelected, type, currentResolution, componentChildren) {
    const {width, maxWidth, height, padding, margin, background, position, left, top} = styles;
    if (type === 'panel') {
        let {maximumHeight} = checkChildrenDimensions(componentChildren, currentResolution); //used for set height in to panel in percent from children
        return {
            ...styles,
            height: maximumHeight ? maximumHeight : 'auto'
        }
    }
    if (type === 'survey') {
        return {
            width: '100%',
            height: 'auto',
            border: isSelected ? `1px dashed ${primaryDropColor}` : '1px dashed transparent',
        }
    }
    if (type === 'button') {
        return {
            ...styles,
            padding: 1,
            background: 'transparent',
            border: isSelected ? `1px dashed ${primaryDropColor}` : '1px dashed transparent',
        }
    }
    if (type === 'field') {
        return {
            width: styles.fullWidth ? '100%' : 'auto',
            height: 'auto',
            border: isSelected ? `1px dashed ${primaryDropColor}` : '1px dashed transparent',
        }
    }
    if (type === 'card') {
        return {
            width: width ? stylesLength > 1 ? 'auto' : width : 'auto',
            height: height ? stylesLength > 1 ? 'auto' : height : 'auto',
            border: isSelected ? `1px dashed ${primaryDropColor}` : '1px dashed transparent',
            margin,
            background
        }
    }
    if (type === 'block') {
        return {
            width: width ? stylesLength > 1 ? 'auto' : width : 'auto',
            maxWidth: maxWidth === 'auto' ? width : maxWidth,
            height: height ? stylesLength > 1 ? 'auto' : height : 'auto',
            border: isSelected ? `1px dashed ${primaryDropColor}` : '1px dashed transparent',
            margin,
            background
        }
    }
    if (type === 'tabs') {
        return {
            width: width ? width : 'auto',
            height: height ? height : 'auto',
            border: isSelected ? `1px dashed ${primaryDropColor}` : '1px dashed transparent',
            padding,
            margin,
        }
    }
    if (type === 'header') {
        return {
            ...styles,
            padding: 0
        }
    }
    const adaptiveWidth = typeof width === 'object' ? width[currentResolution] : width;
    return {
        width: width ? adaptiveWidth : 'auto',
        height: height ? height : 'auto',
        border: isSelected ? `1px dashed ${primaryDropColor}` : '1px dashed transparent',
        padding,
        margin,
        background,
        position,
        left,
        top
    }
}